<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
	<div class="cards-holder devices-tab">
		<div class="card card1 mRight devices-carousel creative-performance-stats detail-colors">
			<div class="preRoll-creative-completion-stats-container">
				<div class="title">
					<h4>Overall Completion Rates</h4>
				</div>
				<div class="preRoll-creative-completion-stats-scroll-div" *ngIf="hasData && overallCompletionData">
					<div class="preRoll-creative-completion-stats">
						<div class="preRoll-creative-header-content text-font-bold add-color">Started</div>
						<div class="preRoll-creative-views par-title-font add-color">
							100% / {{ overallCompletionData.startedValue | formatNumber }} Views
						</div>
						<div class="progressbar">
							<div class="primary-color-bg-right-gradient preroll-bg-right-gradient"></div>
						</div>
					</div>
					<div class="preRoll-creative-completion-stats">
						<div class="preRoll-creative-header-content text-font-bold add-color">25% Completed</div>
						<div class="preRoll-creative-views par-title-font add-color">
							{{ overallCompletionData.quarter }}% / {{ overallCompletionData.quarterValue | formatNumber }} Views
						</div>
						<div class="progressbar">
							<div
								class="primary-color-bg-right-gradient"
								[ngStyle]="getPercentage(overallCompletionData.quarter)"
							></div>
						</div>
					</div>
					<div class="preRoll-creative-completion-stats">
						<div class="preRoll-creative-header-content text-font-bold add-color">50% Completed</div>
						<div class="preRoll-creative-views par-title-font add-color">
							{{ overallCompletionData.half }}% / {{ overallCompletionData.halfValue | formatNumber }} Views
						</div>
						<div class="progressbar">
							<div class="primary-color-bg-right-gradient" [ngStyle]="getPercentage(overallCompletionData.half)"></div>
						</div>
					</div>
					<div class="preRoll-creative-completion-stats">
						<div class="preRoll-creative-header-content text-font-bold add-color">75% Completed</div>
						<div class="preRoll-creative-views par-title-font add-color">
							{{ overallCompletionData.threeQuarters }}% /
							{{ overallCompletionData.threeQuartersValue | formatNumber }} Views
						</div>
						<div class="progressbar">
							<div
								class="primary-color-bg-right-gradient"
								[ngStyle]="getPercentage(overallCompletionData.threeQuarters)"
							></div>
						</div>
					</div>
					<div class="preRoll-creative-completion-stats">
						<div class="preRoll-creative-header-content text-font-bold add-color">100% Completed</div>
						<div class="preRoll-creative-views par-title-font add-color">
							{{ overallCompletionData.completed }}% / {{ overallCompletionData.completionValue | formatNumber }} Views
						</div>
						<div class="progressbar">
							<div
								class="primary-color-bg-right-gradient"
								[ngStyle]="getPercentage(overallCompletionData.completed)"
							></div>
						</div>
					</div>
				</div>
				<div class="no-data-container" *ngIf="!hasData">
					<app-loader [showLoader]="showLoad"></app-loader>
					<div class="map-no-data" *ngIf="!showLoad">No Data to Display</div>
				</div>
			</div>
		</div>
		<div
			class="card card3 mLeft preroll-creative-v3-carousel-cntr devices-carousel creative-performance-stats display-creative-container"
		>
			<div *ngIf="hasData && displayData">
				<ngu-carousel
					#carousel
					[inputs]="carouselOne"
					(carouselLoad)="initDataFn($event)"
					(onMove)="onmoveFn($event)"
					[dataSource]="displayData"
				>
					<span NguCarouselPrev class="leftRs">
						<i class="fa fa-angle-left" aria-hidden="true"></i>
					</span>
					<span NguCarouselNext class="rightRs">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</span>
					<ngu-tile *nguCarouselDef="let creative" NguCarouselItem>
						<div
							class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
						>
							<div class="o-stack__cell portlet-subheader-wrapper">
								<span class="preroll_creative_icon" *ngIf="hasData && downloadConfiguration.enableDownload">
									<a
										href="javascript:void(0)"
										class="datatable_download_icon creative_download_icon"
										(click)="downloadCSV($event)"
										target="_blank"
									>
										<i class="fa fa-download" aria-hidden="true"></i>
									</a>
								</span>
								<h5>{{ setDisplayProperties.name }}</h5>
								<h6 *ngIf="setDisplayProperties.mp4 == ''" class="portlet-subheader nodata-portlet-subheader">
									No Data to Display
								</h6>
								<h6
									*ngIf="setDisplayProperties.mp4 == null && !setDisplayProperties.audioURL"
									class="portlet-subheader"
								>
									No Video to Play
								</h6>
							</div>
						</div>
					</ngu-tile>
					<button NguCarouselPrev class="leftRs">&lt;</button>
					<button NguCarouselNext class="rightRs">&gt;</button>
					<ul
						class="carousel-points-container myPoint"
						NguCarouselPoint
						*ngIf="carousel.pointNumbers && carousel.pointNumbers.length > 1"
					>
						<li
							*ngFor="let j of carousel.pointNumbers; let k = index"
							[class.active]="j == carousel.activePoint"
							(click)="carousel.moveTo(k)"
						></li>
					</ul>
				</ngu-carousel>
				<div class="analytics-portlet-Img100p display-preroll-carousel-height" *ngIf="hasData">
					<div
						class="c-portlet o-block u-width-100p _u-width-100p widget-grid u-shadow-mini u-bg-primary u-color-white-900 c-portlet_box_specs"
					>
						<div class="c-portlet__content u-pt-small">
							<div class="o-stack o-stack center preroll-creative-img" id="videoDisplayblock">
								<div class="video-width">
									<div class="align-controls" *ngIf="!setDisplayProperties.audioURL">
										<div class="ShowControls" [hidden]="setDisplayProperties.mp4 == ''">
											<video
												class=""
												(click)="controlsOptions()"
												id="preRollvideo"
												autoplay
												#videoName
												[src]="setDisplayProperties.mp4"
											>
												<source type="video/mp4" />
												Your browser does not support HTML5 video.
											</video>
											<div class="showIconsControls" *ngIf="displayData && displayData.length > 0">
												<span class="playVideo" (click)="playclickEvent()">
													<img id="playBtn" class="volumeClass" src="./assets/images/play.png" />
												</span>
												<span class="playVideo" (click)="pauseclickEvent()">
													<img id="pauseBtn" class="volumeClass" src="./assets/images/pause.png" />
												</span>
											</div>
										</div>
										<div class="volumecontrols">
											<span id="volumeBtn" class="volumeControlIcon" (click)="volumeclick()">
												<!--<i class="volumecontrols fa fa-volume-up"></i>-->
												<span class="VolumeControlHoverClass">&nbsp;&nbsp;&nbsp;MUTE&nbsp;&nbsp;&nbsp;</span>
												<img id="volumebtn" class="volumeClass" src="./assets/images/muteicon.png" />
											</span>
											<span id="muteBtn" class="volumeControlIcon" (click)="muteclick()">
												<!--<i class="volumecontrols fa fa-volume-off"></i>-->
												<span class="VolumeControlHoverClass">UNMUTE</span>
												<img id="mutebtn" class="volumeClass" src="./assets/images/unmuteicon.png" />
											</span>
										</div>
									</div>

									<div class="audio-container card-long-img" *ngIf="setDisplayProperties.audioURL">
										<div class="audio-icon-block" *ngIf="setDisplayProperties?.audioURL !== ''; else noAudioCreative">
											<svg
												width="250px"
												height="250px"
												viewBox="0 0 250 250"
												version="1.1"
												xmlns="http://www.w3.org/2000/svg"
												xmlns:xlink="http://www.w3.org/1999/xlink"
											>
												<title>Streaming Audio Icon</title>
												<g id="Streaming-Audio-Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													<rect id="Rectangle" x="0" y="0" width="250" height="250"></rect>
													<path
														d="M109,57 C111.761424,57 114,59.2385763 114,62 L114,188 C114,190.761424 111.761424,193 109,193 C106.238576,193 104,190.761424 104,188 L104,62 C104,59.2385763 106.238576,57 109,57 Z M125,76 C127.761424,76 130,78.2385763 130,81 L130,169 C130,171.761424 127.761424,174 125,174 C122.238576,174 120,171.761424 120,169 L120,81 C120,78.2385763 122.238576,76 125,76 Z M173,80 C175.761424,80 178,82.2385763 178,85 L178,165 C178,167.761424 175.761424,170 173,170 C170.238576,170 168,167.761424 168,165 L168,85 C168,82.2385763 170.238576,80 173,80 Z M93,84 C95.7614237,84 98,86.2385763 98,89 L98,161 C98,163.761424 95.7614237,166 93,166 C90.2385763,166 88,163.761424 88,161 L88,89 C88,86.2385763 90.2385763,84 93,84 Z M141,92 C143.761424,92 146,94.2385763 146,97 L146,153 C146,155.761424 143.761424,158 141,158 C138.238576,158 136,155.761424 136,153 L136,97 C136,94.2385763 138.238576,92 141,92 Z M77,98 C79.7614237,98 82,100.238576 82,103 L82,147 C82,149.761424 79.7614237,152 77,152 C74.2385763,152 72,149.761424 72,147 L72,103 C72,100.238576 74.2385763,98 77,98 Z M157,100 C159.761424,100 162,102.238576 162,105 L162,145 C162,147.761424 159.761424,150 157,150 C154.238576,150 152,147.761424 152,145 L152,105 C152,102.238576 154.238576,100 157,100 Z M189,106 C191.761424,106 194,108.238576 194,111 L194,139 C194,141.761424 191.761424,144 189,144 C186.238576,144 184,141.761424 184,139 L184,111 C184,108.238576 186.238576,106 189,106 Z M61,115 C63.7614237,115 66,117.238576 66,120 L66,130 C66,132.761424 63.7614237,135 61,135 C58.2385763,135 56,132.761424 56,130 L56,120 C56,117.238576 58.2385763,115 61,115 Z M45,120 C47.7614237,120 50,122.238576 50,125 C50,127.761424 47.7614237,130 45,130 C42.2385763,130 40,127.761424 40,125 C40,122.238576 42.2385763,120 45,120 Z M205,120 C207.761424,120 210,122.238576 210,125 C210,127.761424 207.761424,130 205,130 C202.238576,130 200,127.761424 200,125 C200,122.238576 202.238576,120 205,120 Z"
														id="Combined-Shape"
														fill="#3EB5AD"
														class="primary-svg-fill"
													></path>
												</g>
											</svg>
											<div class="audio-file-block">
												<audio
													#videoName
													id="preRollvideo"
													class="audioCreative"
													[src]="setDisplayProperties?.audioURL"
													[controls]="'controls'"
													[controlsList]="'nodownload'"
													autoplay="false"
												></audio>
											</div>
										</div>
										<ng-template #noAudioCreative>
											<div class="icon-block no-audio-creative">
												NO DATA AVAILABLE
											</div>
										</ng-template>
									</div>

									<div>
										<div>
											<ul class="preRoll-creative-stats creative-stats">
												<li>
													<span class="stats preRoll-creative-header-content">{{
														setDisplayProperties.impressions | formatNumber
													}}</span>
													<span class="stats-label preRoll-creative-views">IMPRESSIONS</span>
												</li>
												<li *ngIf="!isAudioCreative">
													<span class="stats preRoll-creative-header-content">{{
														setDisplayProperties.clicks | formatNumber
													}}</span>
													<span class="stats-label preRoll-creative-views">CLICKS</span>
												</li>
												<li *ngIf="!isAudioCreative">
													<span class="stats preRoll-creative-header-content"
														>{{ setDisplayProperties.click_rate }}%</span
													>
													<span class="stats-label preRoll-creative-views">CLICK RATE</span>
												</li>
												<li>
													<span class="stats preRoll-creative-header-content">{{
														setDisplayProperties.percent_value_100 | formatNumber
													}}</span>
													<span class="stats-label preRoll-creative-views">COMPLETIONS</span>
												</li>
												<li class="preroll-completion-rate">
													<span class="stats preRoll-creative-header-content"
														>{{ setDisplayProperties.completion_rate | formatNumber }}%</span
													>
													<span class="stats-label preRoll-creative-views">COMPLETION RATE</span>
												</li>
												<li *ngIf="youtubeViewsPermission && isPreroll" class="preroll-youtube-views">
													<span class="stats preRoll-creative-header-content">{{ setDisplayProperties.youtube_verified_imprs | formatNumber }}</span>
													<span class="stats-label preRoll-creative-views">YOUTUBE VIEWS</span>
												</li>
												<li *ngIf="youtubeViewsPermission && isPreroll" class="preroll-youtube-views-rate">
													<span class="stats preRoll-creative-header-content">{{ setDisplayProperties.youtube_verified_imprs_rate | formatNumber }}%</span>
													<span class="stats-label preRoll-creative-views">YOUTUBE VIEW RATE</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div class="preroll-table-header">
									<div class="table-header_label" *ngIf="displayData && displayData.length > 0">
										<div (click)="circleVideoClickEvent(0)" class="preroll-creative-table_svg_content">
											<div id="percent0" class="creative_text_mask">
												<div class="preRoll-creative-header-content add-color">Started</div>
												<div class="preRoll-creative-views">
													{{ setDisplayProperties.impressions | formatNumber }} Views
												</div>
											</div>
											<div class="c100 small p100" [ngClass]="{ noHover: isAudioCreative }">
												<div id="creative_mask_0" class="creative_mask"></div>
												<span class="add-color">100%</span>
												<div class="slice">
													<div class="bar"></div>
													<div class="primary-color-border fill"></div>
												</div>
											</div>
										</div>
										<div class="preroll-creative-table_svg_content">
											<div (click)="circleVideoClickEvent(25)" class="preroll-creative-progress-50">
												<div id="percent25" class="creative_text_mask">
													<div class="preRoll-creative-header-content">25% Completed</div>
													<div class="preRoll-creative-views">
														{{ setDisplayProperties.percent_value_25 | formatNumber }} Views
													</div>
												</div>
												<div class="c100 small" [ngClass]="getPercentageClass(setDisplayProperties.percent_rate_25)">
													<div id="creative_mask_25" class="creative_mask"></div>
													<span>{{ setDisplayProperties.percent_rate_25 }}%</span>
													<div class="slice">
														<div class="bar"></div>
														<div class="primary-color-border fill"></div>
													</div>
												</div>
											</div>
											<div (click)="circleVideoClickEvent(50)" class="preroll-creative-progress-50">
												<div id="percent50" class="creative_text_mask">
													<div class="preRoll-creative-header-content">50% Completed</div>
													<div class="preRoll-creative-views">
														{{ setDisplayProperties.percent_value_50 | formatNumber }} Views
													</div>
												</div>
												<div class="c100 small" [ngClass]="getPercentageClass(setDisplayProperties.percent_rate_50)">
													<div id="creative_mask_50" class="creative_mask"></div>
													<span>{{ setDisplayProperties.percent_rate_50 }}%</span>
													<div class="slice">
														<div class="bar"></div>
														<div class="primary-color-border fill"></div>
													</div>
												</div>
											</div>
										</div>
										<div class="preroll-creative-table_svg_content">
											<div (click)="circleVideoClickEvent(75)" class="preroll-creative-progress-50">
												<div id="percent75" class="creative_text_mask">
													<div class="preRoll-creative-header-content">75% Completed</div>
													<div class="preRoll-creative-views">
														{{ setDisplayProperties.percent_value_75 | formatNumber }} Views
													</div>
												</div>
												<div class="c100 small" [ngClass]="getPercentageClass(setDisplayProperties.percent_rate_75)">
													<div id="creative_mask_75" class="creative_mask"></div>
													<span>{{ setDisplayProperties.percent_rate_75 }}%</span>
													<div class="slice">
														<div class="bar"></div>
														<div class="primary-color-border fill"></div>
													</div>
												</div>
											</div>
											<div (click)="circleVideoClickEvent(100)" class="preroll-creative-progress-50">
												<div id="percent100" class="creative_text_mask">
													<div class="preRoll-creative-header-content">100% Completed</div>
													<div class="preRoll-creative-views">
														{{ setDisplayProperties.percent_value_100 | formatNumber }} Views
													</div>
												</div>
												<div class="c100 small" [ngClass]="getPercentageClass(setDisplayProperties.percent_rate_100)">
													<div id="creative_mask_100" class="creative_mask"></div>
													<span>{{ setDisplayProperties.percent_rate_100 }}%</span>
													<div class="slice">
														<div class="bar"></div>
														<div class="primary-color-border fill"></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<app-loader [showLoader]="showLoad"></app-loader>
				<div class="map-no-data" *ngIf="!showLoad">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
